import React from 'react';
import PropTypes from 'prop-types';

export default function Week({ children }) {
  return <tr>{children}</tr>;
}

Week.propTypes = {
  children: PropTypes.node.isRequired,
};
